/**
 * 동영상
 */
import { useCallback, Fragment } from 'react';
import { useOption } from '@hooks/useOption';
import { SERVICE_ALIAS } from '@constants/service';
import { setYMDDateFormat } from '@utils/index';
import type { IVideo, ISetVideo, l10nType } from '@type/index';

export const setVideoItem = (item: IVideo, serviceAlias: string): ISetVideo | null => {
  if (!item || typeof item !== 'object') {
    return null;
  }

  return {
    ...item,
    target: '_blank',
    providerName: 'YouTube', // 혜림님께 내일 cp 값 여쭤보기
  };
};

const VideoArticle = ({ item, l10n, btnClickCallback }: { item: IVideo; l10n: l10nType; btnClickCallback?: (url: string) => void }) => {
  const { serviceAlias } = useOption();
  const data = setVideoItem(item, serviceAlias);

  if (!data) {
    return <Fragment />;
  }

  const { url, target, thumbnail, title, providerName, date, readCount } = data;

  const clickCallback = useCallback(() => {
    typeof btnClickCallback === 'function' && btnClickCallback(url);
  }, [url]);

  return (
    <div className={`search-item-content ${SERVICE_ALIAS.AION}`}>
      <div className="search-item-thumbnail">
        <a href={url} target={target}>
          <div className="thumb-wrap">{thumbnail ? <img src={thumbnail} alt="" /> : <Fragment />}</div>
        </a>
      </div>
      <div className="search-item-article">
        <div className="search-item-title">
          <a href={url} target={target} dangerouslySetInnerHTML={{ __html: title }}></a>
        </div>
        <div className="search-item-info">
          <span className="provider">{providerName}</span>
          <span>{setYMDDateFormat(date)}</span>
          <span className="count">{readCount}</span>
        </div>
        <div className="search-item-info">
          <button type="button" className="btn-play" onClick={clickCallback}>
            {l10n?.template?.nowShow}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoArticle;
